/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
async function check_pre_order_limit(formElement) {
  let variant_id = parseInt(formElement.querySelector('[name="id"]').value);
  if(formElement.querySelector('#product-preorder-data')) {
    let pre_order_data = JSON.parse(formElement.querySelector('#product-preorder-data').textContent);
    let matchedVariant = pre_order_data.variants.find(variant => variant.variant_id === variant_id);
    let selectedQuantity =  parseInt(formElement.querySelector(".quantity-selector__value").value);
    let pre_order_limit = parseInt(matchedVariant.pre_order_limit);
    return await checkPreorderLimit(variant_id, selectedQuantity, pre_order_limit);
  } else {
    return false; 
  }
}
function getCartQuantity(variantId, callback) {
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    const cartItem = cart.items.find(item => item.variant_id === variantId);
    callback(cartItem ? cartItem.quantity : 0);
  })
  .catch(error => console.error("Error fetching cart data:", error));
}
function showBanner(message) {
  const banner = document.getElementById("preorder-warning-banner");
  const bannerText = document.getElementById("preorder-warning-text");
  bannerText.textContent = message;
  banner.style.top = "20px";
  setTimeout(() => {
    if (banner.style.top === "20px") {
      banner.style.top = "-300px";
    }
  }, 10000);
}
/*
 * OPPRYDDING (2026-07-31, BUGS #3): denne linja kastet
 * "Cannot read properties of null (reading 'addEventListener')" paa passord- og
 * gavekortsiden. #preorder-close-btn finnes kun i layout/theme.liquid, men
 * custom.js lastes ogsaa fra password.liquid og gift-card.liquid.
 *
 * Ingenting gikk i stykker — funksjonsdeklarasjoner heises, saa
 * checkPreorderLimit, getCartQuantity og check_pre_order_limit fantes fortsatt
 * etter feilen (verifisert i isolert Chrome-test). Men det var en roed feilmelding
 * i konsollen paa to sider. Optional chaining fjerner den uten aa endre oppfoersel
 * der elementet faktisk finnes.
 */
document.getElementById("preorder-close-btn")?.addEventListener("click", function () {
  const banner = document.getElementById("preorder-warning-banner");
  if (banner) {
    banner.style.top = "-300px";
  }
});
function checkPreorderLimit(variantId, selectedQuantity, pre_order_limit) {
  return new Promise((resolve) => {
    getCartQuantity(variantId, function (cartQuantity) {
      const totalQuantity = cartQuantity + selectedQuantity;
      if (totalQuantity > pre_order_limit) {
        showBanner(`Vi har kun ${pre_order_limit} igjen på lager`);
        resolve(true);
      } else {
        resolve(false);
      }
    });
  });
}
/*
 * syncExpandableAria (2026-08-19, Jacobs regel for kategoribeskrivelser)
 *
 * Temaets sammenfoldbare tekst (`expandable-content`) holder tilstanden sin i
 * `aria-expanded` paa WRAPPEREN. Det er theme.js sin handler som skriver den
 * (`parentSection.setAttribute("aria-expanded", ...)`), og CSS-en henger paa
 * den samme selektoren.
 *
 * Problemet: det er KNAPPEN en skjermleser annonserer, ikke wrapperen. En
 * knapp uten `aria-expanded` leses opp som en helt vanlig knapp, uten aa si
 * om innholdet er aapent eller lukket.
 *
 * 🔴 HVORFOR IKKE BARE FLYTTE ATTRIBUTTET TIL KNAPPEN
 * `expandable-content` brukes fire steder — én paa kolleksjonssiden og TRE paa
 * produktsiden. theme.js leser attributtet fra wrapperen paa alle fire. Aa
 * flytte det ville brutt produktsidens beskrivelse og to innholdsblokker for
 * aa rette en a11y-detalj paa kolleksjonssiden. Speiling er den trygge veien:
 * wrapperen forblir sannhetskilden, knappen foelger etter.
 *
 * MutationObserver og ikke en klikk-handler, med vilje: theme.js sin egen
 * handler er delegert paa document.body, og rekkefoelgen mellom to
 * klikk-lyttere paa samme element er ikke noe vi skal vaere avhengige av.
 * Ved aa observere selve attributtet treffer vi alltid etter at det er skrevet,
 * uansett hvem som skrev det.
 */
(function () {
  function syncOne(wrapper) {
    var button = wrapper.querySelector('.expandable-content__toggle');
    if (!button) return;
    button.setAttribute('aria-expanded', wrapper.getAttribute('aria-expanded') === 'true' ? 'true' : 'false');
  }

  function init() {
    var wrappers = document.querySelectorAll('.expandable-content[aria-expanded]');
    if (!wrappers.length) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'aria-expanded') {
          syncOne(m.target);
        }
      });
    });

    wrappers.forEach(function (w) {
      syncOne(w);
      observer.observe(w, { attributes: true, attributeFilter: ['aria-expanded'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * clampToCharacterBudget (2026-08-19)
 *
 * Setter hoyden paa sammenfoldbare kategoribeskrivelser slik at omtrent
 * TEGNBUDSJETTET er synlig — ikke et fast antall linjer.
 *
 * 🔴 HVORFOR DETTE MAA VAERE JS
 * Kravet er i tegn: «over 280 tegn skal gi Les mer». CSS kan bare telle
 * linjer, og hvor mange tegn en linje rommer avhenger av containerbredden.
 * Maalt paa SAMME kolleksjon: 72 tegn/linje ved 961px viewport, 117 ved
 * 1440px. Et fast linjetall bommer derfor alltid i den ene eller andre
 * enden. To forsok bommet paa nettopp dette:
 *   - 2 linjer desktop: knappen (58px, solid hvit) dekket hele teksten
 *   - 4 linjer desktop: rommet 436 tegn paa 1440px, saa en tekst paa 352
 *     tegn fikk plass og knappen forsvant. Det var feilen paa /collections/fiam.
 *
 * 🔴 MAA KJORE ETTER theme.js — DET VAR DEN ANDRE FEILEN
 * theme.js har sin egen `processCollapsibles()` som fjerner knappen naar den
 * maaler at teksten faar plass. `custom.js` lastes FOR `theme.js` i
 * theme.liquid, og begge er `defer` — de kjorer derfor i dokumentrekkefolge,
 * med custom.js FORST. Kjorer vi klampen med én gang, maaler theme.js
 * etterpaa mot CSS-fallbacken (4 linjer), konkluderer «faar plass» og setter
 * aria-expanded="true". Knappen forsvinner selv om teksten er over 280 tegn.
 *
 * Derfor: aldri kjor synkront. `DOMContentLoaded` fyrer etter ALLE deferrede
 * skript, og `setTimeout(0)` daekker tilfellet der dokumentet alt er parset.
 * Etter at hoyden er satt, avgjor vi selv om det finnes skjult tekst — og
 * overstyrer da theme.js sin konklusjon.
 *
 * 🔴 FLOOR, IKKE CEIL — det er dette som GARANTERER knappen.
 * linjer = floor(280 / tegnPerLinje) gjor at det synlige omraadet alltid
 * rommer MINDRE enn 280 tegn. Enhver tekst over 280 tegn maa da flyte over,
 * og knappen blir staaende. Med ceil kunne en tekst paa f.eks. 300 tegn faa
 * plass, og knappen ville forsvunnet selv om teksten er over terskelen.
 *
 * Prisen er at synlig mengde ligger litt UNDER 280. Det er riktig vei aa
 * bomme: kravet er at knappen skal finnes over 280 tegn.
 *
 * TEKSTEN ER ALDRI BERORT — dette setter kun `max-height` paa wrapperen.
 * Hele teksten ligger i HTML uansett, jf. collapsible-text.liquid.
 */
(function () {
  var TEGNBUDSJETT = 280;
  var MIN_LINJER = 2;

  function beregnHoyde(wrapper) {
    var rte = wrapper.querySelector('.rte');
    if (!rte) return null;
    // 🔴 Reserver plass etter knappens FAKTISKE hoyde, ikke en hardkodet
    // verdi. CSS setter --lesmer-toggle-space som utgangspunkt, men knappen
    // varierer med skriftstorrelse og kan brekke til to linjer paa en smal
    // skjerm eller med en lengre tekst. Blir den hoyere enn reservasjonen,
    // legger den seg oppaa teksten igjen — det var feilen 2026-08-19.
    // Maalt: 38px desktop, 36px mobil.
    var knapp = wrapper.querySelector('.expandable-content__toggle');
    if (knapp) {
      var knappH = knapp.getBoundingClientRect().height;
      if (knappH > 0) wrapper.style.paddingBottom = Math.ceil(knappH) + 'px';
    }


    // Mal fri hoyde: fjern taket midlertidig, les, sett tilbake.
    var forrigeMax = wrapper.style.maxHeight;
    var forrigeTrans = wrapper.style.transition;
    wrapper.style.transition = 'none';
    wrapper.style.maxHeight = 'none';
    void wrapper.offsetHeight;

    var lh = parseFloat(getComputedStyle(rte).lineHeight);
    var fullHoyde = rte.getBoundingClientRect().height;
    var tegn = rte.textContent.trim().length;

    wrapper.style.maxHeight = forrigeMax;
    void wrapper.offsetHeight;
    wrapper.style.transition = forrigeTrans;

    if (!lh || !fullHoyde || !tegn) return null;

    var tegnPerLinje = tegn / (fullHoyde / lh);
    if (!tegnPerLinje) return null;

    var linjer = Math.max(MIN_LINJER, Math.floor(TEGNBUDSJETT / tegnPerLinje));
    // box-sizing er border-box, saa knappens reserverte plass maa inn i taket.
    var knappPlass = parseFloat(getComputedStyle(wrapper).paddingBottom) || 0;
    return { hoyde: linjer * lh + knappPlass, harMer: tegn > TEGNBUDSJETT };
  }

  function clampEn(wrapper, init) {
    var m = beregnHoyde(wrapper);
    if (!m) return;

    wrapper.dataset.lesmerMaxHeight = m.hoyde + 'px';

    if (init) {
      // Overstyr theme.js sin konklusjon: er teksten over budsjettet, SKAL
      // den vaere sammenfoldet og knappen synlig.
      wrapper.setAttribute('aria-expanded', m.harMer ? 'false' : 'true');
      wrapper.classList.toggle('expandable-content--expandable', m.harMer);
    }

    if (wrapper.getAttribute('aria-expanded') === 'false') {
      wrapper.style.maxHeight = m.hoyde + 'px';
    } else {
      wrapper.style.maxHeight = '';
    }
  }

  function clampAlle(init) {
    var els = document.querySelectorAll('.expandable-content--clamped');
    for (var i = 0; i < els.length; i++) clampEn(els[i], init);
  }

  function start() { clampAlle(true); }

  var timer;
  function planlegg() {
    clearTimeout(timer);
    timer = setTimeout(function () { clampAlle(false); }, 150);
  }

  /*
   * 🔴 Gjenopprett hoyden etter at temaet har foldet sammen igjen.
   *
   * theme.js sin lukke-gren gjor:
   *     style.max-height = offsetHeight + 'px'   // frys naavaerende hoyde
   *     void offsetHeight                        // tving reflow
   *     style.max-height = null                  // la CSS ta over
   *
   * Den siste linja NULLER ut den beregnede hoyden vaar, og CSS-fallbacken
   * (4 linjer) tar over. Resultatet: forste visning er riktig, men etter én
   * aapne/lukke-runde viser boksen plutselig mer enn tegnbudsjettet.
   *
   * Vi observerer derfor aria-expanded og setter hoyden tilbake. setTimeout(0)
   * fordi mutasjonen fyrer FOR max-height-jongleringen over er ferdig — uten
   * den ville vaar verdi blitt overskrevet av  rett etterpaa.
   */
  /*
   * 🔴 Fjern den redundante margen theme.js legger paa ved utfolding.
   *
   * theme.js gjor, i utfold-grenen:
   *     expandableButton.previousElementSibling.style['margin-bottom']
   *       = expandableButton.clientHeight + 'px'
   *
   * Forelderen til knappen er `.rte`, saa teksten skyves ned med hele
   * knappens hoyde. Hensikten er aa hindre at den absolutt posisjonerte
   * knappen legger seg oppaa siste tekstlinje.
   *
   * Men VI reserverer allerede den plassen med `padding-bottom` paa
   * wrapperen. Margen blir dermed en ANDRE reservasjon av samme plass, og de
   * legger seg oppaa hverandre. Maalt utfoldet paa 1280px: 58px margin +
   * 58px knapp = 116px dodt rom mellom siste tekstlinje og bunnen.
   *
   * Fjerner vi margen alene, halveres det til 58px. Sammen med den krympede
   * knappen (38px) blir det ~38px.
   *
   * setTimeout(0) fordi mutasjonen fyrer FOR theme.js har rukket aa sette
   * margen — uten den ville vaar nullstilling blitt overskrevet rett etterpaa.
   */
  function fjernRedundantMargin(wrapper) {
    var rte = wrapper.querySelector('.rte');
    if (rte) rte.style.marginBottom = '';
  }

  function overvaakLukking() {
    var els = document.querySelectorAll('.expandable-content--clamped');
    var obs = new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        var el = m.target;
        setTimeout(function () {
          // Begge retninger: theme.js setter margen ved utfolding og nuller
          // max-height ved lukking. Vi rydder etter begge.
          fjernRedundantMargin(el);
          if (el.getAttribute('aria-expanded') === 'false' && el.dataset.lesmerMaxHeight) {
            el.style.maxHeight = el.dataset.lesmerMaxHeight;
          }
        }, 0);
      });
    });
    for (var i = 0; i < els.length; i++) {
      obs.observe(els[i], { attributes: true, attributeFilter: ['aria-expanded'] });
    }
  }

  // 🔴 Aldri synkront — se rekkefolge-merknaden over.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); overvaakLukking(); });
  } else {
    setTimeout(function () { start(); overvaakLukking(); }, 0);
  }
  window.addEventListener('resize', planlegg);
  document.addEventListener('shopify:section:load', start);
})();


/*
  «Lurer du paa noe? Still et spoersmaal» ved kjoepsknappen (2026-08-25).

  Delegerer til Judge.me sitt EGET skjema i stedet for aa bygge vaart eget.
  Vi eier ingen skjemalogikk, ingen GDPR-tekst, ingen e-postvarsling og ingen
  av appens ~20 norske tekststrenger — alt det finnes allerede i widgeten.
  Et eget skjema mot Judge.mes API ville vaert en andre sannhetskilde.

  MAALT 2026-08-25: et syntetisk klikk paa `.jdgm-ask-question-btn` faar
  Judge.me til aa bygge `.jdgm-question-form` (den lages lazy, foerst ved
  klikk). Skjemaet rendres INLINE i anmeldelsesfanen, ikke i en modal —
  derfor maa fanen aapnes og kunden scrolles dit.

  🔴 EKSISTENS, IKKE SYNLIGHET. Vi sjekker at knappen FINNES, aldri om den
     er synlig. Judge.me avsloerer og oversetter knappene i et sent init-
     steg som ikke kjoerer i en fane som ikke komponerer frames — en maaling
     der rapporterer `display: none` og engelsk tekst selv naar kunden ser
     den synlig og paa norsk. Det er F1. En synlighetssjekk her ville gjort
     knappen vaar usynlig i akkurat de miljoeene.

  🔴 DELEGERING, IKKE DIREKTE LISTENER. Kjoepsknapp-omraadet ligger i
     <product-rerender>, og `.product-form__payment-container` byttes ut ved
     variantbytte. En listener paa selve knappen ville doedd der. Samme
     rotaarsak som BUGS #39.

  🔴 preventDefault + stopPropagation fordi knappen ligger INNE i
     produktskjemaet. Se kommentaren i product-buy-buttons.liquid.
*/
(function () {
  var JUDGE = '.jdgm-ask-question-btn';
  var VAAR = '.ms-ask-question';

  function judgeKnapp() {
    return document.querySelector(JUDGE);
  }

  function visKnappene() {
    var n = document.querySelectorAll(VAAR);
    for (var i = 0; i < n.length; i++) n[i].classList.add('is-klar');
  }

  // Judge.me lastes asynkront. Bundet observer, ikke evig -- den kobles fra
  // saa snart knappen finnes, og uansett etter 15s.
  function ventPaaJudgeMe() {
    // 🔴 INGEN KNAPP PAA SIDEN -> INGENTING AA GJOERE. Lagt til 2026-09-11 etter
    //    Lighthouse-maaling. Uten denne sperren satte vi opp en dokument-
    //    omfattende MutationObserver i 15 sekunder paa ALLE sider — forside,
    //    kurv, kolleksjoner — og lette etter en Judge.me-knapp som aldri
    //    kommer der. Hver DOM-endring fra Klaviyo, Clarity, Selleasy og
    //    slideshowet fyrte callbacken. Liten kostnad per kall, men null nytte,
    //    og det var det eneste i denne fila som kjoerte under sidelasting
    //    utenfor produktsiden.
    if (!document.querySelector(VAAR)) return;
    if (judgeKnapp()) { visKnappene(); return; }
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      if (judgeKnapp()) { obs.disconnect(); visKnappene(); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  // Fanen er kollapset som standard. theme.js animerer den, saa vi gir den
  // et oeyeblikk foer vi klikker videre.
  function aapneAnmeldelsesfanen(naar) {
    var fane = document.querySelector('[data-id="reviewsTab"]');
    if (!fane || fane.getAttribute('aria-expanded') === 'true') { naar(); return; }
    fane.click();
    setTimeout(naar, 200);
  }

  // 🔴 Feil B, samme melding: Judge.me fokuserer SELV sitt foerste felt
  //    («Visningsnavn») naar skjemaet aapner. Paa mobil spretter tastaturet da
  //    opp og dekker widgeten -- akkurat det vi fjernet vaart eget focus() for
  //    aa unngaa. Min egen test bommet fordi den bare saa etter <textarea>,
  //    ikke navnefeltet.
  //
  //    Vi tar fokus TILBAKE TIL VAAR EGEN KNAPP i stedet for aa blur()-e.
  //    En <button> aapner ikke det virtuelle tastaturet, og tastaturbrukere
  //    beholder en fornuftig posisjon rett over skjemaet. blur() ville dumpet
  //    fokus til <body>, slik at Tab startet paa nytt fra toppen av siden.
  //
  //    Bevisst BUNDET i tid, og bare naar fokus faktisk staar inne i skjemaet:
  //    kunden skal kunne trykke seg inn i feltet selv rett etterpaa uten aa bli
  //    kastet ut. Derfor ingen varig focusin-vakt.
  function taFokusTilbake(trigger, skjema) {
    function tilbake() {
      var a = document.activeElement;
      if (a && skjema.contains(a) && trigger.focus) {
        trigger.focus({ preventScroll: true });
      }
    }
    tilbake();
    setTimeout(tilbake, 120);
    setTimeout(tilbake, 300);
  }

  function absoluttTopp(el) {
    return (window.pageYOffset || document.documentElement.scrollTop || 0) +
           el.getBoundingClientRect().top;
  }

  // 🔴 Et element som ikke er layoutet gir getBoundingClientRect() = bare
  //    nuller. Uten hoeyde/bredde-sjekken leses top===0 som «perfekt i bildet»,
  //    og etterkontrollen hopper over en scroll som aldri skjedde.
  function harLayout(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return (r.height > 0 || r.width > 0) &&
           (el.offsetHeight > 0 || el.offsetParent !== null);
  }

  function iBildet(el) {
    if (!harLayout(el)) return false;
    var r = el.getBoundingClientRect();
    return r.top >= 0 && r.top < window.innerHeight * 0.6;
  }

  // Skjemaet foretrekkes, men bare naar det faktisk har en boks. Ellers
  // widget-containeren. Aldri noe urendret -- da blir absoluttTopp lik
  // naavaerende scrollposisjon, og «scrollingen» blir et null-hopp.
  function velgMaal() {
    var skjema = document.querySelector('.jdgm-question-form');
    if (harLayout(skjema)) return skjema;
    var widget = document.querySelector('#judgeme_product_reviews');
    if (harLayout(widget)) return widget;
    return null;
  }

  function scrollTil(y) {
    if (y < 0) y = 0;
    try {
      window.scrollTo({ top: y, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, y); // eldre nettlesere uten options-varianten
    }
  }

  // 🔴 Feil meldt av Jacob 2026-08-25, tredje runde: han ble fortsatt ikke
  //    scrollet ned til widgeten paa telefon.
  //
  //    AARSAK: anmeldelsesfanen aapnes med en slideDown-HOEYDEANIMASJON
  //    (theme.js). Mens den kjoerer VOKSER dokumentet, saa maalet vaart flytter
  //    seg nedover under hele scrollingen. En smooth scroll mot et maal i
  //    bevegelse blir typisk avbrutt av nettleseren -- og paa mobil ble
  //    resultatet at ingenting skjedde i det hele tatt.
  //
  //    Vi venter derfor til posisjonen har STABILISERT seg (to like maalinger
  //    paa rad) foer vi scroller, og etterkontrollerer at vi faktisk landet.
  //    scrollTo med utregnet posisjon framfor scrollIntoView, fordi vi da kan
  //    legge inn luft over widgeten -- temaet har sticky header paa mobil, og
  //    `block: 'center'` tok ikke hoeyde for den.
  function scrollNaarKlar() {
    var forrige = null, stabile = 0, frist = Date.now() + 5000;

    (function sjekk() {
      var maal = velgMaal();

      // 🔴 Feil meldt av Jacob 2026-08-25, fjerde runde: fortsatt to trykk.
      //    Aarsak: forrige versjon scrollet saa snart .jdgm-question-form
      //    FANTES i DOM. Ved foerste klikk er den nettopp opprettet og ikke
      //    layoutet ennaa -- rect er bare nuller. Da ble maalposisjonen lik
      //    naavaerende scroll (ingen bevegelse), OG etterkontrollen trodde vi
      //    var framme. Ved andre klikk laa skjemaet ferdig layoutet, og alt
      //    virket. Derfor: vent paa LAYOUT, ikke paa eksistens.
      if (!maal) {
        if (Date.now() > frist) { return; }
        setTimeout(sjekk, 100);
        return;
      }

      var naa = Math.round(absoluttTopp(maal));
      if (naa === forrige) { stabile++; } else { stabile = 0; forrige = naa; }

      if (stabile >= 2 || Date.now() > frist) {
        var maalY = absoluttTopp(maal) - window.innerHeight * 0.25;
        scrollTil(maalY);

        setTimeout(function () {
          if (!iBildet(maal)) {
            var y = absoluttTopp(maal) - window.innerHeight * 0.25;
            window.scrollTo(0, y < 0 ? 0 : y);
          }
        }, 900);
        return;
      }
      setTimeout(sjekk, 120);
    })();
  }

  // Judge.me markerer tilstand paa wrapperen: display:none naar skjemaet er
  // LUKKET, ingen style naar det er AAPENT. Maalt 2026-08-25.
  //
  // 🔴 Dette er et STYLE-attributt, ikke layout. Det kan derfor leses selv naar
  //    anmeldelsesfanen fortsatt er kollapset -- og det er noekkelen til at vi
  //    kan aapne skjemaet PARALLELT med at fanen folder seg ut, i stedet for aa
  //    vente paa den foerst.
  //
  // 📌 Rettelse til en tidligere kommentar i denne fila: aria-expanded ble
  //    beskrevet som upaalitelig. Det stemmer ikke. Den sa "false" mens skjemaet
  //    fantes -- men skjemaet var da faktisk LUKKET. Attributtet fortalte
  //    sannheten; tolkningen min var feil.
  function skjemaErAapent() {
    var w = document.querySelector('.jdgm-question-form-wrapper');
    if (!w) return false;
    return (w.style.display || '') !== 'none';
  }

  // 🔴 MEKANIKKEN, maalt 2026-08-25: FOERSTE klikk paa Judge.me-knappen
  //    OPPRETTER skjemaet, men lar det staa LUKKET. ANDRE klikk aapner det.
  //    Det er den egentlige grunnen til at Jacob maatte trykke to ganger helt
  //    fra starten -- ikke timing, slik jeg foerst antok.
  //
  //    Vi klikker derfor til tilstanden sier AAPENT, med minst 100 ms mellom
  //    hvert klikk saa vi ikke rekker aa toggle den igjen foer tilstanden er
  //    oppdatert. Typisk to klikk paa rundt 150 ms.
  function aapneSkjema(jdgm, ferdig) {
    var maks = 4, forsok = 0, sisteKlikk = 0, frist = Date.now() + 3000;

    (function steg() {
      if (skjemaErAapent()) {
        ferdig(document.querySelector('.jdgm-question-form'));
        return;
      }
      if (forsok >= maks || Date.now() > frist) {
        ferdig(null);
        return;
      }
      if (Date.now() - sisteKlikk >= 100) {
        forsok++;
        sisteKlikk = Date.now();
        jdgm.click();
      }
      setTimeout(steg, 60);
    })();
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest(VAAR);
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    var jdgm = judgeKnapp();
    if (!jdgm) { return; }

    // 🔴 Start bevegelsen MED EN GANG. Tidligere ventet vi paa at fanen skulle
    //    aapne seg OG skjemaet bli klart foer vi scrollet i det hele tatt --
    //    Jacob opplevde det som en merkbar pause der ingenting skjedde.
    //    Faneknappen er alltid layoutet, saa den kan vi sikte paa umiddelbart.
    //    Naar skjemaet er klart, finjusterer scrollNaarKlar() posisjonen.
    var fane = document.querySelector('[data-id="reviewsTab"]');
    if (harLayout(fane)) {
      scrollTil(absoluttTopp(fane) - window.innerHeight * 0.15);
    }

    // 🔴 PARALLELT, ikke i serie. Tidligere ventet vi 200 ms paa at fanen skulle
    //    aapne seg foer vi i det hele tatt roerte Judge.me-knappen. Den
    //    ventetiden er unoedvendig: knappen kan klikkes mens den er skjult, og
    //    tilstanden leses fra et style-attributt som ikke krever layout.
    aapneAnmeldelsesfanen(function () {});
    aapneSkjema(jdgm, function (skjema) {
      scrollNaarKlar();
      if (skjema) taFokusTilbake(trigger, skjema);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ventPaaJudgeMe);
  } else {
    ventPaaJudgeMe();
  }
  document.addEventListener('shopify:section:load', ventPaaJudgeMe);
})();
